import { forwardRef } from 'react';
import { cn } from '../utils/cn';

export const Skeleton = forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div
      ref={ref}
      className={cn(
        'rounded-md bg-gradient-to-r from-ink-100 via-ink-200 to-ink-100',
        'bg-[length:200%_100%] animate-shimmer',
        className
      )}
      {...props}
    />
  )
);
Skeleton.displayName = 'Skeleton';
